export const REST_SHUT_REQUEST = 'REST_SHUT_REQUEST'
export const REST_SHUT_SUCCESS = 'REST_SHUT_SUCCESS'
export const REST_SHUT_FALIURE = 'REST_SHUT_FALIURE'
export const REST_POST_SHUT_REQUEST = 'REST_POST_SHUT_REQUEST'
export const REST_POST_SHUT_SUCCESS = 'REST_POST_SHUT_SUCCESS'
export const REST_POST_SHUT_FALIURE = 'REST_POST_SHUT_FALIURE'
export const REST_POST_SHUT2_REQUEST = 'REST_POST_SHUT2_REQUEST'
